import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import _ from "lodash";

const MySummary = (props) => {
  return (
    <>
      <Row>
        <Col>
          <h3 className="my-3 title">My Attendance Summary</h3>
        </Col>
      </Row>
      <Card border="light" className="shadow dashboardStats my-4">
        <Card.Body>
          <Row>
            <Col xs="6" lg="4">
              <div className="d-flex justify-content-center align-items-center">
                
                <div className="alert bg-success text-white title mx-2 px-2">
                  {_.get(props, "summary.ontime", 0) || 0}
                </div>
                <div>
                  <span className="d-block mb-2 subtitle">On Time</span>
                  <small>(This Year)</small>
                </div>
              </div>
            </Col>
            <Col xs="6" lg="4">
              <div className="d-flex justify-content-center align-items-center">
               
                <div className="alert bg-danger text-white title mx-2 px-2">
                  {_.get(props, "summary.differed", 0) || 0}
                </div>
                <div>
                  <span className="d-block mb-2 subtitle">Differed Time</span>
                  <small>(This Year)</small>
                </div>
              </div>
            </Col>
            <Col xs="6" lg="4">
              <div className="d-flex justify-content-center align-items-center">
                
                <div className="alert bg-primary text-white title mx-2 px-2">
                  {_.get(props, "summary.total", 0) || 0}
                </div>
                <div>
                  <span className="d-block mb-2 subtitle">Total</span>
                  <small>(Hours)</small>
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default MySummary;
